import React from "react";
import PropTypes from "prop-types";

const HighchartsReact = window.HighchartsReact;

class USAMap extends React.Component {
  constructor(props) {
    super(props);

    this.updateMap = this.updateMap.bind(this);
    this.selectState = this.selectState.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.selectedState !== prevProps.selectedState) {
      this.selectState(this.props.selectedState);
    }
  }

  selectState(code) {
    const data = this.chart.series[0].data;
    if (code !== "all") {
      return data.forEach(country => {
        if (country["hc-key"] === code) {
          country.update({ selected: true });
        } else if (country["hc-key"] !== code && country.selected === true) {
          country.update({ selected: false });
        }
        return country;
      });
    }
    return data.map(country => country.selected === true ? country.update({ selected: false }) : country);
  }

  updateMap(chart) {
    this.chart = chart;
    this.selectState(this.props.selectedState);
  }

  render() {
    const { options, highcharts } = this.props;
    return (
      <HighchartsReact
        highcharts={highcharts}
        constructorType={"mapChart"}
        options={options}
        callback={this.updateMap}
        key={this.props.selectedState}
      />
    );
  }
}

USAMap.propTypes = {
  highcharts: PropTypes.shape({
    charts: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  }).isRequired,
  options: PropTypes.shape({}).isRequired,
  selectedState: PropTypes.string.isRequired
};

export default USAMap;
